import React from 'react'
import { ReactComponent as ChartPlaceholder } from './chart-placeholder.svg'
import chartPlaceholderArea from './chart-placeholder-area.svg'
import { Loader } from 'bzx-common/src/ui-framework'

interface IChartLoaderProps {
  showLoader?: boolean
  children?: React.ReactNode
  type: 'candle' | 'area'
}

const chartTypes: Record<'candle' | 'area', { className: string; placeholder: React.ReactNode }> = {
  candle: {
    className: 'chart__loader flex-col flex-center z-100',
    placeholder: <ChartPlaceholder className="chart__placeholder" />,
  },
  area: {
    className: 'chart__loader--area',
    placeholder: <img src={chartPlaceholderArea} className="chart__placeholder-area" />,
  },
}

/**
 * Loader for chart
 */
export function ChartLoader(props: IChartLoaderProps) {
  const { children, showLoader, type } = props
  const { className, placeholder } = chartTypes[type]

  return (
    <div className={className}>
      {placeholder}
      {showLoader ? (
        <div className="chart__loader-txt">
          <Loader quantityDots={3} sizeDots="small" />
        </div>
      ) : (
        <p className="txt-size-12 txt-default txt-muted chart__loader-txt">{children}</p>
      )}
    </div>
  )
}

export default React.memo(ChartLoader)
